export class Microsoft365ConnectionInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "appClientId",
            "baseName": "appClientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "permissions",
            "baseName": "permissions",
            "type": "Array<Microsoft365Permission>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365ConnectionInfo.attributeTypeMap;
    }
    constructor() {
    }
}
